import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SocialRegistration = () => {
  const socialProviders = [
    {
      name: 'Google',
      icon: 'Chrome',
      color: 'hover:bg-red-50 hover:border-red-200',
      textColor: 'text-red-600'
    },
    {
      name: 'Apple',
      icon: 'Apple',
      color: 'hover:bg-gray-50 hover:border-gray-200',
      textColor: 'text-gray-800'
    },
    {
      name: 'Microsoft',
      icon: 'Square',
      color: 'hover:bg-blue-50 hover:border-blue-200',
      textColor: 'text-blue-600'
    }
  ];

  const handleSocialLogin = (provider) => {
    console.log(`Social registration with ${provider}`);
    // Implement social registration logic here
  };

  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-background text-muted-foreground">Or continue with</span>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3">
        {socialProviders.map((provider) => (
          <Button
            key={provider.name}
            variant="outline"
            size="lg"
            fullWidth
            onClick={() => handleSocialLogin(provider.name)}
            className={`${provider.color} transition-all duration-200 ease-out`}
          >
            <div className="flex items-center justify-center space-x-3">
              <Icon name={provider.icon} size={20} className={provider.textColor} />
              <span className="font-medium">Continue with {provider.name}</span>
            </div>
          </Button>
        ))}
      </div>

      <div className="text-center">
        <p className="text-xs text-muted-foreground">
          By continuing, you agree to our Terms of Service and Privacy Policy
        </p>
      </div>
    </div>
  );
};

export default SocialRegistration;